var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-progress",attrs:{"id":"FileProgress"}},[_c('div',{style:({width: '70vw', maxWidth: '600px'})},[_c('div',{style:({position: 'relative'})},[_c('div',{style:({padding: '20px'})},[_c('span',{staticClass:"textBar"},[_vm._v(_vm._s(_vm.currentfile)+" de "+_vm._s(_vm.filesTotal)+" enviadas")])]),_vm._v(" "),_c('div',{style:({
            width : this.percentage + '%',
            backgroundColor: 'white',
            height: '12px',
            borderRadius: '12px',
            position:'absolute' })}),_vm._v(" "),_c('div',{staticClass:"progressBar"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57eb26d3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/FileProgress.vue
// module id = 1630
// module chunks = 5